module.exports = __webpack_public_path__ + "media/images/checkbox-small-checked-415d32519fb4a224103fac9d0aec5759.svg";